import { GridActionHandlerBase } from "./grid-action-handler-base";

/**
 * Thriggers the Kendo Grid's built-in Excel export
 */
export class ExcelExportGridActionHandler extends GridActionHandlerBase {
  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    this.workspace.grid.exportToExcel(this.workspace.grid.kendoGrid);
  }
}
